module.exports = __webpack_public_path__ + "static/media/nvphFrame.aeed95f3.webp";